"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var ButtonPrim_1 = require("components/Buttons/ButtonPrim");
var ListCol_1 = __importDefault(require("components/Lists/ListCol"));
var ListColBase_1 = __importDefault(require("components/Lists/ListColBase"));
var ScrollIntoViewRow_1 = __importDefault(require("components/Lists/ScrollIntoViewRow"));
var ReferenceForm_1 = __importDefault(require("containers/Admin/References/ReferenceForm"));
var PREFIX = 'AdminReferenceRow';
var classes = {
    formWrapper: "".concat(PREFIX, "-formWrapper"),
};
var StyledScrollIntoViewRow = (0, styles_1.styled)(ScrollIntoViewRow_1.default)(function () {
    var _a;
    return (_a = {},
        _a[".".concat(classes.formWrapper)] = { overflow: 'visible' },
        _a);
});
var AdminReferenceRow = function (_a) {
    var _b;
    var item = _a.item, isActive = _a.isActive, services = _a.services;
    var _c = __read(react_1.default.useState(false), 2), formIsOpen = _c[0], openForm = _c[1];
    return ((0, jsx_runtime_1.jsxs)(StyledScrollIntoViewRow, __assign({ active: isActive, className: (0, clsx_1.default)('py-0') }, { children: [(0, jsx_runtime_1.jsx)(ListCol_1.default, __assign({ width: 34 }, { children: item.reference })), !formIsOpen
                ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ListCol_1.default, __assign({ width: 16 }, { children: item.serviceName })), (0, jsx_runtime_1.jsx)(ListCol_1.default, __assign({ width: 16 }, { children: (_b = services === null || services === void 0 ? void 0 : services.find(function (srv) { return item.serviceId === srv.id; })) === null || _b === void 0 ? void 0 : _b.name })), (0, jsx_runtime_1.jsx)(ListCol_1.default, __assign({ width: 16 }, { children: item.rePattern })), (0, jsx_runtime_1.jsx)(ListCol_1.default, __assign({ width: 10 }, { children: item.keyword })), (0, jsx_runtime_1.jsx)(ListCol_1.default, __assign({ width: 6 }, { children: (0, jsx_runtime_1.jsx)(ButtonPrim_1.ButtonPrim, __assign({ onClick: function () { return openForm(true); } }, { children: "Edit" })) }))] }))
                : ((0, jsx_runtime_1.jsx)(ListColBase_1.default, __assign({ className: classes.formWrapper, width: 43 }, { children: (0, jsx_runtime_1.jsx)(ReferenceForm_1.default, { reference: item, closeForm: function () { return openForm(false); }, services: services }) })))] })));
};
exports.default = AdminReferenceRow;
